const accountsFilter = [
    '/_/accounts',
    '/_/transactions',
    '/_/withdrawals',
    '/_/payouts',
    '/_/chargebacks',
    '/_/refunds',
    '/_/risks',
    '/_/activity',
    '/_/activations',
    '/_/invoices',
    '/_/whitelist',
    '/_/rules',
    '/_/rules/timeline',
    '/_/transfers',
    '/_/affiliations',
    '/_/affiliation-requests',
    '/_/integrations',
    '/_/pos_information',
    '/_/tap-to-phone-devices',
    '/_/subscriptions',
    '/_/blacklisted-cards'

];

export default accountsFilter;